import request from '@/libs/http/index'

// 更新门店切换
export const updateDept = data => {
  return request.put({ url: '/system/user/update-dept', data })
}
// 消息列表
export const getNoticePage = params => {
  return request.get({ url: '/system/notice/tenant-page', params })
}
// 消息详情
export const getNoticeDetail = params => {
  return request.get({ url: '/system/notice/get', params })
}
// 消息详情
export const noticeReadAll = data => {
  return request.post({ url: '/system/notice/read-all', data })
}
// 菜单栏数量角标
export const executionEsCountType = params => {
  return request.get({ url: '/clinic/execution/es-count-type', params })
}
// 未读消息数量
export const getUnreadCount = params => {
  return request.get({ url: '/system/notice/get-unread-count', params })
}

// 获取未读消息数量设置
export const getUnreadCountSettings = params => {
  return request.get({
    url: '/clinic/settings-execution/get-todo-number-settings',
    params,
  })
}
